export const getCertificateEndpoint = (medicId: string) =>
    `/api/DigitalCertificate/${medicId}`;
